import React, { useEffect } from "react";
import { createContext, useState } from "react";
import PropTypes from 'prop-types';


export const APP_CLIENT_ID ='69a42976-f3ae-4f72-94e2-9961408cad5e';
export const APP_CLIENT_SECRET = '32e5be60-8976-4583-af32-077b5b3ebc64';
export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState({
        user_name: '',
        first_name:'',
        last_name: '',
        roles: [],
        token: null
    });


    const login = (userData)=> {
        setUser(JSON.parse(userData));
      
    };
    useEffect(()=> {
        localStorage.removeItem('loggedInUser');
        const currentUser = localStorage.getItem('loggedInUser');
        console.log("current User: " + currentUser);
        if (currentUser != null) {
            setUser(JSON.parse(currentUser));
        }
    },[]);
    const value = { user, setUser, login}


return (<AuthContext.Provider value={value }>
            { children }
        </AuthContext.Provider>);
    }

export default AuthContext;

AuthProvider.propTypes = {
    children: PropTypes.any,
};